import React from "react";
import { Link } from "react-router-dom";

const PortfolioBanner = () => {
  return (
    <>
      <section
        className="breadcrumb__area include-bg pt-150 pb-150 breadcrumb__overlay Portfolio_banner"
        // data-background="assets/img/breadcrumb/slider11.png"
        style={{
          backgroundImage: `url("assets/img/breadcrumb/slider11.png")`,
          zIndex:'0'
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-xxl-12">
              <div className="breadcrumb__content text-center p-relative z-index-1">
                <h3 className="breadcrumb__title">Portfolio</h3>
                <div className="breadcrumb__list">
                  <span>
                    <Link to="/">Home</Link>
                  </span>
                  <span className="dvdr">:</span>
                  <span>Portfolio</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PortfolioBanner;
